module.exports = __webpack_public_path__ + "img/Weapon_289.1e2e3c30.png";